import axiosInstance from './axios';

export const referralService = {
  createCampaign: async (payload: { name: string; code: string }) => {
    const response = await axiosInstance.post('/client/referral/campaigns', payload);
    return response.data;
  },
  getCampaigns: async (params?: { limit?: number; page?: number }) => {
    const response = await axiosInstance.get('/client/referral/campaigns', { params });
    return response.data;
  },
  getReferrals: async (params?: { limit?: number; page?: number }) => {
    const response = await axiosInstance.get('/client/referral/referrals', { params });
    return response.data;
  },
  getPayoutSummary: async () => {
    const response = await axiosInstance.get('/client/referral/payout/summary');
    return response.data;
  },
};
